module.exports = __webpack_public_path__ + "img/banner-en.bcb4b680.png";